import type { FC, PropsWithChildren } from "react"
import { MainSidebar } from "./sidebar"
import { SidebarProvider } from "@/app/providers/SidebarProvider"
import { useSidebarContext } from "@/app/providers/useSidebarContext"
import { useDevice } from "@shared/hooks"
import { WatchConfirmSubmitProvider } from "@/model"
import { ImpersonationBanner } from "@/components/ImpersonationBanner"

interface NavbarSidebarLayoutProps {
  withOutMainSidebar?: boolean
}

const NavbarSidebarLayout: FC<PropsWithChildren<NavbarSidebarLayoutProps>> = ({ children, withOutMainSidebar }) => {
  const { isDesktop } = useDevice()

  return (
    <WatchConfirmSubmitProvider>
      <SidebarProvider>
        <div className="flex flex-col h-screen">
          <ImpersonationBanner />
          <div className={`flex-1 min-h-0 w-full ${isDesktop ? "flex items-start" : ""}`}>
            <SidebarContent withOutMainSidebar={withOutMainSidebar}>{children}</SidebarContent>
          </div>
        </div>
      </SidebarProvider>
    </WatchConfirmSubmitProvider>
  )
}

interface SidebarContentProps {
  withOutMainSidebar?: boolean
}

const SidebarContent: FC<PropsWithChildren<SidebarContentProps>> = ({ children, withOutMainSidebar }) => {
  const { toggleSidebar } = useSidebarContext()
  const { isDesktop } = useDevice()

  return (
    <>
      {!withOutMainSidebar && <MainSidebar closeSidebar={toggleSidebar} />}
      <main
        className={`relative min-h-screen h-screen bg-customGray-100 transition-all ${isDesktop ? "grow overflow-x-hidden" : "w-full"}`}
      >
        {children}
      </main>
    </>
  )
}

export default NavbarSidebarLayout
